module.exports = __webpack_public_path__ + "img/smartBaby.a47c7dc3.gif";